const getEnv = () => {
    const host = window.location.hostname.toLowerCase();

    if ( host.includes( 'qa.' ) || host.includes( 'localhost' ) ) {
        return 'qa.';
    }
    if ( host.includes( 'pprd.' ) ) {
        return 'pprd.';
    }

    return '';
};

export const ENV = getEnv();
